// extracted by mini-css-extract-plugin
export default {"common-embed-wrapper":"CommonEmbed_common-embed-wrapper__hxCj0","common-embed-content":"CommonEmbed_common-embed-content__n-QhL","common-iframe":"CommonEmbed_common-iframe__lwfo-"};